import img13a from '../../../assets/gallery/13d/13d-01-HOME_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';
import img13b from '../../../assets/gallery/13d/13d-02_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';
import img13c from '../../../assets/gallery/13d/13d-03_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';
import img13d from '../../../assets/gallery/13d/13d-04_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';
import img13e from '../../../assets/gallery/13d/13d-05_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img13a,
    description: "2013",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img13b,
    description: "2013",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img13c,
    description: "2013",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img13d,
    description: "2013",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img13e,
    description: "2013",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/13d/data13d.js